import { API_HOST, AXIOS_INSTANCE } from './api'
import axios from 'axios'

const RESULTS = "results";
const RESULTS_COUNT = "count";

export async function LIST_RESULTS() {
    const response = await AXIOS_INSTANCE.get(`${API_HOST}/${RESULTS}`, {
      headers: {
        'Authorization': 'Bearer ' + window.localStorage.getItem('token'),
        'Accept': 'application/json'
      }
    });
    return response.data;
}

export async function GET_RESULTS_COUNT() {
  try {
    const response = await AXIOS_INSTANCE.get(`${API_HOST}/${RESULTS}/${RESULTS_COUNT}`, {
      headers: {
        'Authorization': 'Bearer ' + window.localStorage.getItem('token')
      }
    });
    return response.data;
  } catch (e) {
    catchError(e);
  }
}



// WEBPACK FOOTER //
// ./src/services/result.js